<div class="antialiased bg-slate-200  min-h-screen">

  <app-sidebar></app-sidebar>

  <div class="mx-auto lg:ml-80 lg:mr-8 pb-4">

    <app-tabs></app-tabs>


    <div class="relative overflow-x-auto shadow-md sm:rounded-lg lg:mt-8 mb-8">

      <div class="p-5 rounded-tl-md rounded-tr-md  bg-white border-b border-slate-300">
        <h3
          class="text-base md:text-lg font-medium text-left rtl:text-right text-gray-900  dark:text-white dark:bg-gray-800">
          Analytics</h3>
        <p class="mt-1 text-sm font-normal text-gray-500 dark:text-gray-400">
        </p>
      </div>
      <!-- <ng-container *ngIf="!dataFound && !loader">
                <div class="flex justify-center pb-8 pt-8">
                    <img src="/assets/images/no-data.svg" style="height: 40vh;" alt="">
                </div>
                <div class="flex justify-center pb-8">
                    <p>No Data found</p>
                </div>
            </ng-container> -->


      <ng-container>
        <div class="w-full bg-white text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">

          <div class=" p-5 flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between ">

            <div class="">
              <app-dropdown-radio [options]="filterOptions"
                (optionSelected)="onOptionSelected($event)"></app-dropdown-radio>
            </div>

            <label for="table-search" class="sr-only">Search</label>
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor"
                  viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"></path>
                </svg>
              </div>
              <input type="text" id="table-search" (keyup)="handleSearch($event)"
                class="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-full md:w-80 bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Search for items">
            </div>
          </div>

          <div class="overflow-x-auto">
            <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">


              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                    S.no
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Page
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Spend time
                  </th>
                  <th scope="col" class="px-6 py-3">
                    Date / Time (utc)
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="pointer bg-white border-b hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700"
                  *ngFor="let data of analyticData;let i = index;">
                  <td scope="row" class="px-6 py-4">
                    {{startingIndex+i}}
                  </td>
                  <td scope="row" class="px-6 py-4">
                    {{data.page | stringSlice : data.page}}
                  </td>
                  <td class="px-6 py-4">
                    {{data.meta.spend_time}}
                  </td>
                  <td class="px-6 py-4">
                    {{data.updated_at | date : 'MM/dd/y h:mm a' : 'utc'}}
                  </td>
                </tr>
                <tr *ngIf="analyticData && analyticData.length ===0">
                  <td colspan="4">
                    <div class="flex justify-center pb-8 pt-8">
                      <img src="/assets/images/no-data.svg" style="height: 40vh;" alt="">
                    </div>
                    <div class="flex justify-center pb-8">
                      <p>No Data found</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-4 mb-2"> <app-pagination *ngIf="analyticData && analyticData.length > 0"  [totalPages]="totalPages"
                [search]="searchQuery" (advertisingList)="list($event)" [apiUrl]="apiUrl" [currentPage]="currentPage" [days]="filter"
                [limit]="itemsPerPage" (pageChanged)="onPageChange($event)" (startingIndex)="setStartingIndex($event)"
                [totalItems]="totalItems" [firstIndex]="startingIndex">
              </app-pagination>
            </div>
          </div>
        </div>

      </ng-container>
    </div>
  </div>
</div>
<app-api-logs></app-api-logs>